import { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FollowButton from 'src/components/buttons/followButton';
import signupContext from 'src/constants/signupContext';
import { showLoginModal } from 'src/modules/shared/modal/actions';
import { State } from 'src/types';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import { LinkButton } from 'styles-js/buttons';

export default function PrivatePostMessage({children}: {children: ReactNode}) {
  const dispatch = useDispatch();
  const { currentCommunity, currentUser } = useSelector(({context}: State) => context);

  const onClick = () => {
    dispatch(showLoginModal({clickMetaData: {section: 'ConvBoxReply'}}));
  };

  return (
    <Container>
      {children}
      <FollowButton
        buttonText={i18n.t('Join now')}
        buttonType="primary"
        community={currentCommunity}
        followType="group"
        isActive={!!currentUser}
        noIcon={true}
        signupContext={{ section: signupContext.section.CONVERSION_HIDDEN_RESP }}
        user={currentUser}
      />
      {!currentUser &&
        <p>
          <LinkButton onClick={onClick}>
            {i18n.t('Already a member? Log in')}
          </LinkButton>
        </p>
      }
    </Container>
  );
}

const Container = styled.div`
  text-align: center;
  padding: 20px 15px;
  background-color: ${({theme}) => theme.colorBlueBackground};
  margin: 20px auto;

  p {
    margin: 10px 0;
  }
`;
